import $ from 'jquery';
import Vue from 'vue';
import Store from '../../lib/stores/store';
import Instance from './instance.html';
import Spinner from '../../lib/components/spinner/spinner';
import Error from '../../lib/components/error/error';
import EnrollVirtualTrainingProgram from './enrollVirtualTrainingProgram';

const componentId = 'ecEnrollVirtualTrainingProgram';

const elements = $('[data-name="ecEnrollVirtualTrainingProgram"]');
if (elements.length) {
	for (let index = 0; index < elements.length ; index++) {
		let newId = componentId;
		if (elements.length > 1) {
			newId = `${componentId}_${index + 1}`;
			$(elements[index]).attr('id', newId);
		} else if (elements.length === 1) {
			$(elements[index]).attr('id', newId);
		}

		const uuid = $(`#${newId}`).data('uuid');

		const vue = new Vue({
			el: `#${newId}`,
			store: Store,
			template: Instance,
			components: {
				EnrollVirtualTrainingProgram,
				Error,
				Spinner,
			},
			mounted() {
				this.$nextTick(() => {
					const enrollTrainingProgramElements = $('[data-name="ecEnrollVirtualTrainingProgram"]');

					$(enrollTrainingProgramElements[index]).attr('id', newId);
					$(enrollTrainingProgramElements[index]).attr('data-uuid', uuid);
				});
			},
		});
	}
}
